import type { ReactNode } from 'react'

export function AdminPageHero({
  eyebrow,
  title,
  summary,
  children,
}: {
  eyebrow?: string
  title: string
  summary: ReactNode
  children?: ReactNode
}) {
  return (
    <section className="admin-page-hero">
      <div className="admin-page-hero__copy">
        {eyebrow && <div className="admin-page-hero__eyebrow">{eyebrow}</div>}
        <h1>{title}</h1>
        <p>{summary}</p>
      </div>
      {children && <div className="admin-page-hero__actions">{children}</div>}
    </section>
  )
}
